var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarkComplete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.6889,
    height: 19.2111,
    rx: 2.95556,
    fill: "#261966"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2656 15.834C6.95191 15.834 4.26562 13.1477 4.26562 9.83398C4.26562 6.52027 6.95191 3.83398 10.2656 3.83398C13.5793 3.83398 16.2656 6.52027 16.2656 9.83398C16.2656 13.1477 13.5793 15.834 10.2656 15.834ZM9.66718 12.234L13.9098 7.99134L13.0613 7.14282L9.66718 10.5369L7.97015 8.83984L7.12162 9.68842L9.66718 12.234Z",
    fill: "#159A1A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarkComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mark-complete.ddfaffcfe3022aefa85123d0bcc85ee7.svg";